export interface TTestimonials {
  author: string;
  text: string;
}

export const TESTIMONIALS: TTestimonials[] = [
  {
    author: 'AtLeastSignificant',
    text:
      'MyCrypto is the definition of a successful grass-roots movement for the community, by the community.',
  },
  {
    author: 'Nick Johnson',
    text:
      'MyCrypto provides some of the best and most carefully thought-through tools available in the Ethereum community.',
  },
  {
    author: 'Raymond Durk',
    text:
      'MyCrypto has consistently released the perfect balance between personal security, user experience, and new features.',
  },
  {
    author: 'Andrew Coathup',
    text:
      'I love the MyCrypto team, with their focus on education and security for the entire community.  Friendly, responsive, passionate and generous.',
  },
  {
    author: 'James Ryan Moreau',
    text:
      'MyCrypto is one of the most responsive teams in the entire blockchain space when it comes to thinking about users and their general well-being.',
  },
  {
    author: 'Tim Coulter',
    text:
      'MyCrypto is the leader in blockchain wallets. Their watchful eye on security and their close proximity to users put them on the front lines, shepherding users through the new and exciting world of crypto.',
  },
];
